import React, { useRef } from "react";
import { Container } from "@mui/material";
import { motion, useReducedMotion, useScroll, useSpring } from "framer-motion";
import { Palette, Draw, Share, Publish, Dashboard } from "@mui/icons-material";
import { HowItWorksWrapper } from "./styles";
import Reveal from "../../Components/Reveal";
import PageIntro from "../../Components/PageIntro";
import PageConversion from "../../Components/PageConversion";
const HowItWorks = () => {
	const steps = [
		{
			step: "Step 01",
			title: "Choose Your Template",
			description: "Explore our beautifully crafted templates, designed to match a variety of styles and tastes.",
			icon: () => <Palette />
		},
		{
			step: "Step 02",
			title: "Customize Tt Your Way",
			description: "Make every detail yours—from colors to text—just the way you like it.",
			icon: () => <Draw />
		},
		{
			step: "Step 03",
			title: "Publish Invitation",
			description: "Make your invitation live and ready to impress your guests instantly.",
			icon: () => <Publish />
		},
		{
			step: "Step 04",
			title: "Share",
			description: "Reach your guests on multiple social platforms, share via direct link or QR code effortlessly.",
			icon: () => <Share />
		},
		{
			step: "Step 05",
			title: "Manage RSVPs",
			description:
				"Keep all guest responses in one dashboard—monitor RSVPs, view attendance status, and get real-time updates as replies come in.",
			icon: () => <Dashboard />
		}
	];

	const timelineRef = useRef<HTMLDivElement>(null);
	const reduce = useReducedMotion();
	const { scrollYProgress } = useScroll({ target: timelineRef, offset: ["start 70%", "end 60%"] });
	const scaleY = useSpring(scrollYProgress, { stiffness: 90, damping: 22 });

	return (
		<HowItWorksWrapper>
			<Container>
				<PageIntro title={"How it works"}>
					Browse beautiful invitation designs, customize every detail, manage RSVPs, and share your invitation and
						album with ease — all in one place.
				</PageIntro>
				<div className={"timeline"} ref={timelineRef}>
					<div className={"track"} />
					<motion.div className={"progress"} style={{ scaleY: reduce ? 1 : scaleY }} />
					{steps.map(step => (
						<Reveal key={step.step}>
							<div className={"step"}>
								<div className={"badge"}>{step.icon()}</div>
								<p className={"step-label"}>{step.step}</p>
								<h3 className={"step-title"}>{step.title}</h3>
								<p className={"step-description"}>{step.description}</p>
							</div>
						</Reveal>
					))}
				</div>
			</Container>
			<PageConversion />
		</HowItWorksWrapper>
	);
};

export default HowItWorks;
